invHdApp.controller('DayendController', ['$scope', 'Dayend', '$location','$routeParams','$filter',
  function ($scope, Dayend, $location, $routeParams, $filter) {
    $scope.deleted = [];
		$scope.filterData = {
      workers: [],
      page: 1
    }
    
    $scope.all = function (type) {
      if(typeof type !== 'undefined' && type == 'clear') {
				$scope.filterData = {
					term: '',
					workers: [],
					status: null,
					created_at : { 
						startDate: null, 
						endDate: null 
					},
				}
      }
      if($routeParams.status) {
        $scope.filterData.status = $routeParams.status;
      }
      Dayend.all($scope.filterData).success(function(data, status, headers, config) {
        $scope.data = data;
      });
    }

    $scope.$on('completeDayend', function (event,data,nextParams,fromState) {
      var index = $scope.data.dayends.data.indexOf($filter('filter')($scope.data.dayends.data, {id: data.id})[0]);
      if (index > -1)
        $scope.data.dayends.data[index]['status'] = true;
    });
    $scope.$on('unCompleteDayend', function (event,data,nextParams,fromState) {
      var index = $scope.data.dayends.data.indexOf($filter('filter')($scope.data.dayends.data, {id: data.id})[0]);
      if (index > -1)
        $scope.data.dayends.data[index]['status'] = false;
    });

    $scope.getPage = function(page) {
			$scope.filterData.page = page;
			$scope.all();
    }
    
    $scope.sort = function(field,sort) {
			$scope.filterData.field = field;
			$scope.filterData.sort = sort;
			$scope.all();
    }
    
    $scope.clearFilter = function(page) {
			$scope.filterData = {
				workers: [],
				workSteps: [],
				created_at : { 
					startDate: null, 
					endDate: null 
				},
				scheduled_time : { 
					startDate: null, 
					endDate: null
				}
			}
			$scope.filterProp = [];
			$scope.all('clear');
		}


    $scope.get = function () {
      Dayend.get($routeParams.id).success(function(data, status, headers, config) {
        $scope.data = data;
      });
    }
    
    $scope.new = function () {
      Dayend.new().success(function(data, status, headers, config) {
        $scope.data = data;
      });
    }

    $scope.delete = function (type) {
			if(type == 'set') {
        $('#delete').modal('show');
      } else if(type == 'delete') {
				Dayend.delete($scope.deleted).success(function(data, status, headers, config) {
          Messenger().post(data.message);
          for (var i = $scope.deleted.length - 1; i >= 0; i--) {
            var index = $scope.data.dayends.data.indexOf($filter('filter') (
                $scope.data.dayends.data, {id: $scope.deleted[i] })[0]
              );
            if (index > -1)
              $scope.data.dayends.data.splice(index, 1);
          }
          $scope.deleted = [];
          $('#delete').modal('hide');
				}).error(function(data) {
          Messenger().post({message: data.message,type: "error"});
				});
			} 
		}

		$scope.save = function () {
			Dayend.save($scope.dayend).success(function(data, status, headers, config) {
				$scope.data = data;
        Messenger().post(data.message);
        $location.path('stok/urunler');
			}).error(function(data) {
        Messenger().post({message: data.message,type: "error"});
      });
		}

		$scope.update = function () {
			Dayend.update($scope.data.dayend).success(function(data, status, headers, config) {
				$scope.data = data;
        Messenger().post(data.message);
        $location.path('stok/urunler');
			}).error(function(data) {
        Messenger().post({message: data.message,type: "error"});
      });
		}

    $scope.goTo = function(id) {
      $location.path('stok/urun/' + id);
    }

    $scope.customerSelect = function(selected,type) {
      if(typeof type === 'undefined') {
        if(typeof selected !== 'undefined') {
          var customer = selected.originalObject;
        }else {
          var customer = [];
        }
      }else {
        var customer = selected;
      }
      if(typeof customer !== 'undefined' && typeof $scope.dayend !== 'undefined') {
        $scope.dayend.company_customer_id = customer.id;
        $scope.dayend.company_customer = customer.customer_name;
      }
      if(typeof customer !== 'undefined' && typeof $scope.data.dayend !== 'undefined') {
        $scope.data.dayend.company_customer_id = customer.id;
        $scope.data.dayend.company_customer = customer.customer_name;
      }

  }

  $scope.toggleSelection = function toggleSelection(id) {
    var idx = $scope.deleted.indexOf(id);
    if (idx > -1) {
      $scope.deleted.splice(idx, 1);
    }
    else {
      $scope.deleted.push(id);
    }
  };

  }
]);
